import { addRasterOverlay, removeRasterOverlay } from '../raster_helpers';

const lightPollutionId = 'light-pollution';

const addLightPollution = map => {
  const apiKey = 'pk.eyJ1IjoiYWxsdHJhaWxzIiwiYSI6IkZGaGhGLWsifQ.Fl0FrDM8-xonRV6x2HFqcw';
  addRasterOverlay(
    map,
    lightPollutionId,
    `https://api.mapbox.com/styles/v1/alltrails/cjvzvxr4f1oa41ct09tqtsjvp/tiles/512/{z}/{x}/{y}@2x?access_token=${apiKey}`,
    {
      attribution: "<a target='_blank' href='https://www.ngdc.noaa.gov'>NOAA</a>",
      tileSize: 512
    },
    {
      paint: {
        'raster-opacity': 0.5
      }
    }
  );
};

const removeLightPollution = map => {
  removeRasterOverlay(map, lightPollutionId);
};

export { addLightPollution, removeLightPollution };
